module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "md": 8,
      "lg": 5
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "广告描述",
      "clearable": ""
    },
    model: {
      value: (_vm.params.ad_desc),
      callback: function($$v) {
        _vm.$set(_vm.params, "ad_desc", $$v)
      },
      expression: "params.ad_desc"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.numberSearch
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("添加广告")])], 1)], 1), _vm._v(" "), _c('el-row'), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "广告列表",
      "name": "admin"
    }
  }), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.list,
      "height": _vm.wheight - 160
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "id"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "is_publish",
      "label": "是否发布"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": scope.row.is_publish == 0 ? 'info' : 'success',
            "disable-transitions": ""
          }
        }, [_vm._v(_vm._s(scope.row.is_publish == 0 ? '未发布' : '已发布'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "is_publish",
      "label": "是否全店铺"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": scope.row.all_type == 1 ? 'warning' : 'primary',
            "disable-transitions": ""
          }
        }, [_vm._v(_vm._s(scope.row.all_type == 0 ? '部分店铺' : '全平台'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "show_type",
      "label": "显示范围"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.show_type == '0') ? _c('span', [_vm._v("全部显示")]) : _vm._e(), _vm._v(" "), (scope.row.show_type == '1') ? _c('span', [_vm._v("app显示")]) : _vm._e(), _vm._v(" "), (scope.row.show_type == '2') ? _c('span', [_vm._v("小程序显示")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "distributor_name",
      "label": "所属店铺"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.distributorList), function(taglist) {
          return _c('el-tag', {
            key: taglist.index,
            staticStyle: {
              "display": "inline-block",
              "margin-right": "3px"
            },
            attrs: {
              "size": "mini"
            }
          }, [_vm._v("\n            " + _vm._s(taglist.name) + "\n          ")])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "link,short_link,wx_app_link",
      "label": "链接"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          链接：" + _vm._s(scope.row.link) + " "), _c('br'), _vm._v("\n          短连接：" + _vm._s(scope.row.short_link) + " "), _c('br'), _vm._v("\n          小程序连接：" + _vm._s(scope.row.wx_app_link) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "image",
      "label": "图片"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "placement": "right",
            "width": "240",
            "trigger": "hover"
          }
        }, [_c('img', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "src": _vm.wximageurl + scope.row.image
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "slot": "reference",
            "type": "text"
          },
          slot: "reference"
        }, [_c('img', {
          attrs: {
            "src": "/static/img/icon_img.png"
          }
        })])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ad_desc",
      "label": "描述"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sort",
      "label": "排序"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cardname",
      "label": "优惠券"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "operating-icons"
        }, [_c('i', {
          staticClass: "iconfont icon-edit1",
          on: {
            "click": function($event) {
              return _vm.handleUpdate(scope.row)
            }
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.handleEditDistribution(scope.row)
            }
          }
        }, [_vm._v("编辑店铺")]), _vm._v(" "), _c('i', {
          staticClass: "mark iconfont icon-trash-alt1",
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.$index, scope.row)
            }
          }
        })], 1)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.total_count > _vm.params.pageSize) ? _c('div', {
    staticClass: "content-padded content-center"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next, total",
      "current-page": _vm.params.page,
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "添加/编辑广告",
      "visible": _vm.dialog,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "160px"
    },
    model: {
      value: (_vm.form),
      callback: function($$v) {
        _vm.form = $$v
      },
      expression: "form"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "广告简介"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入公告内容,不超过200字"
    },
    model: {
      value: (_vm.form.ad_desc),
      callback: function($$v) {
        _vm.$set(_vm.form, "ad_desc", $$v)
      },
      expression: "form.ad_desc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否公布"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.form.is_publish),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_publish", $$v)
      },
      expression: "form.is_publish"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否全店铺"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.form.all_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "all_type", $$v)
      },
      expression: "form.all_type"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "显示范围"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.show_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "show_type", $$v)
      },
      expression: "form.show_type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("仅app")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    }
  }, [_vm._v("仅小程序")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "排序"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.sort),
      callback: function($$v) {
        _vm.$set(_vm.form, "sort", $$v)
      },
      expression: "form.sort"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "链接"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.link),
      callback: function($$v) {
        _vm.$set(_vm.form, "link", $$v)
      },
      expression: "form.link"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "短链接"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.short_link),
      callback: function($$v) {
        _vm.$set(_vm.form, "short_link", $$v)
      },
      expression: "form.short_link"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "小程序链接"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.wx_app_link),
      callback: function($$v) {
        _vm.$set(_vm.form, "wx_app_link", $$v)
      },
      expression: "form.wx_app_link"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "优惠券"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择优惠券",
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.changeCard(_vm.index)
      }
    },
    model: {
      value: (_vm.form.card_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "card_id", $$v)
      },
      expression: "form.card_id"
    }
  }, _vm._l((_vm.cardList), function(v, i) {
    return _c('el-option', {
      key: v.card_id,
      attrs: {
        "label": v.title,
        "value": v.card_id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgDialog,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeImgDialog
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "图片"
    }
  }, [_c('div', {
    staticClass: "upload-box",
    on: {
      "click": _vm.handleImgPicker
    }
  }, [(_vm.form.image) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.image
    }
  }) : _c('i', {
    staticClass: "iconfont icon-camera avatar-uploader-icon"
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer content-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.clickable
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑店铺",
      "visible": _vm.distributor_dialog,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.distributor_dialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "160px"
    },
    model: {
      value: (_vm.distributor_from),
      callback: function($$v) {
        _vm.distributor_from = $$v
      },
      expression: "distributor_from"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "广告描述"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.distributor_from.ad_desc),
      callback: function($$v) {
        _vm.$set(_vm.distributor_from, "ad_desc", $$v)
      },
      expression: "distributor_from.ad_desc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "图片"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "src": _vm.wximageurl + _vm.distributor_from.image
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "作用门店"
    }
  }, [_vm._l((_vm.relDistributors), function(item, index) {
    return _c('el-tag', {
      key: item.distributor_id,
      staticClass: "new-tag",
      attrs: {
        "closable": "",
        "disable-transitions": false
      },
      on: {
        "close": function($event) {
          return _vm.handleClose(index)
        }
      }
    }, [_vm._v(" " + _vm._s(item.name) + "\n        ")])
  }), _vm._v(" "), _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "medium"
    },
    on: {
      "click": _vm.addDistributoreAction
    }
  }, [_vm._v("+ 点击搜索店铺 ")])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer content-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.clickable
    },
    on: {
      "click": _vm.handleDistributionSave
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('DistributorSelect', {
    attrs: {
      "store-visible": _vm.DistributorVisible,
      "is-valid": _vm.isValid,
      "rel-data-ids": _vm.relDistributors,
      "get-status": _vm.DistributorStatus
    },
    on: {
      "chooseStore": _vm.DistributorChooseAction,
      "closeStoreDialog": _vm.closeDialogAction
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0758ec59", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0758ec59"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/storeshop/alterAd.vue
// module id = 2443
// module chunks = 0